import React from 'react';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import Button from '../../../core/form/Button';
import PropTypes from 'prop-types';

const BannerListFilters = (props) => {
  return (
    <Row>
      <Column size={4}>
        <TextInput
          label='Name'
          value={get(props.values, 'name', null)}
          onChange={(value) => props.onChange('name', value)}
        />
      </Column>
      <Column size={4}>
        <TextInput
          label='Link'
          value={get(props.values, 'link', null)}
          onChange={(value) => props.onChange('link', value)}
        />
      </Column>
      <Column xl={1} xxl={2}>
        <div style={{ height: 44 }} />
        <Button label="Search" icon="search" onClick={props.onSearch} />
      </Column>
    </Row>
  );
};

BannerListFilters.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

BannerListFilters.defaultProps = {
  values: {},
};

export default BannerListFilters;
